import { render } from "./RegistroEncuesta.vue?vue&type=template&id=08831ec4&scoped=true"
import script from "./RegistroEncuesta.vue?vue&type=script&lang=js"
export * from "./RegistroEncuesta.vue?vue&type=script&lang=js"

import "./RegistroEncuesta.vue?vue&type=style&index=0&id=08831ec4&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08831ec4"]])

export default __exports__